import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'

import { showBranches, updateBranches } from '../../../../MyApi/sb/branches'

import PageHeader from '../../../../Components/UI/PageHeader'
import LoadingSpinner from '../../../../Components/UI/spinner'

import EditBranch from '../../../../Components/sb/branches/branchesUpdate/EditBranch'



const BranchesUpdate = () => {
const [ branchName ,setBranchName]= useState("")
const [phone, setPhone] = useState("")
const [address, setAdress] = useState("")
const [timezone , setTimeZone] =useState("")
const [currencyId ,setCurrencyId] = useState("")
const [countryId ,setCountryId]= useState("")
const [companyId ,setCompanyId] = useState("")
const [cityId , setCityId]= useState("")
const [selectedCurrency , setSelectedCurrency] =useState("")
const [selectedCompany , setSelectedCompany] =useState("")
const [selectedCity , setSelectedCity] =useState("")
const [active, setActive]=useState(1)
const [mainStatus ,setMainStatus] =useState(0)
const [shiftId ,setShiftId] =useState([])
const [states ,setStates]=useState("")
const [locations , setLocations]=useState([])
const {id} =useParams()
const lang = localStorage.getItem("i18nextLng")
const [selectedCodeLang ,setSelectedCodeLang]= useState(lang)
const {data, isLoading} = useQuery(["showBranches" ,id, selectedCodeLang],()=>showBranches(id,selectedCodeLang))
const branches =data?.data || []
useEffect(()=>{
  setBranchName(branches.name)
  setPhone(branches.phone)
  setActive(branches.active)
  setMainStatus(branches.main)
  setLocations(branches.locations ||[])
  setShiftId(branches.shifts || [])
  setAdress(branches.address)
  setStates(branches.states)
  setTimeZone(branches.timezone)
  setCurrencyId(branches.sb_currency_id)
  setCountryId(branches.sb_country_id)
  setCompanyId(branches.company_id)
  setCityId(branches.sb_city_id)
  setStates(branches.states)

},[data])
 const mutation = useMutation(["updateBranches",id] , (postData)=>updateBranches(postData ,id) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:branchName,
        phone,
        timezone,
        active,      
        sb_country_id:+countryId,
        sb_company_id:+companyId,
        sb_city_id:+cityId,
        sb_currency_id:+currencyId,
        address,
        shifts:shiftId,
        main:mainStatus,
        states,
        locations ,
        lang_code:selectedCodeLang
    })
 } 
 const onSelectChange=(e)=>{
  const {value}= e.target
  setSelectedCodeLang(value)
 }
 const isDisabled= ()=>{
   return
 }
 if(isLoading){
  return <LoadingSpinner/>
 }
 if(!data){
  return <div>no data available</div>
 }
  return ( 

    <div>
        <PageHeader title="Edit Branch" showSelect onSelectChange={onSelectChange}  showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <EditBranch  currencyId={currencyId} locations={locations}  companyId={companyId}  countryId={countryId}  cityId={cityId}  timezone={timezone}  setLocations={setLocations}  setStates={setStates}  selectedCity={selectedCity}   selectedCurrency={selectedCurrency} selectedCountry={selectedCompany} setSelectedCompany={setSelectedCompany}   setShiftId={setShiftId} shiftId={shiftId}  setCityId={setCityId} setBranchName={setBranchName} setMainStatus={setMainStatus} mainStatus={mainStatus} setCompanyId={setCompanyId} setActive={setActive} setTimeZone={setTimeZone}  setCountryId={setCountryId} setAdress={setAdress} setPhone={setPhone} phone={phone} address={address} setCurrencyId={setCurrencyId}  active={active}  branchName={branchName}/>
    </div>
  )
}

export default BranchesUpdate